import { CommonUtility } from '@utility/common';
import { APIPath } from '../constants';
import { CRUDService } from './crud.ts';
import { BaseService } from './base';

class Pallet extends CRUDService {
  constructor() {
    super(APIPath.pallets);
  }

  generateUrl(feedType, params) {
    return BaseService.get(
      `${APIPath.containerPalletsGenerateUrl}/${feedType}?${CommonUtility.objectToParams(params)}`,
    );
  }

  getFeedTemplate(feedType, params) {
    return BaseService.get(
      `${APIPath.containerPalletsTemplate}/${feedType}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  getFeedLogs(params) {
    return BaseService.get(
      `${APIPath.containerPalletsFeeds}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  getPreviousLabel(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.palletsGenerateLabels}?${query}`);
  }

  bulkCreatePallets(data) {
    return BaseService.post(APIPath.palletsBulkCreate, data);
  }

  generatePalletLabels(data) {
    return BaseService.post(APIPath.palletsGenerateLabels, data);
  }
}

const PalletService = new Pallet();
Object.freeze(PalletService);
export { PalletService };
